import { useCallback, useMemo, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';

import { isNonEmptyArray } from 'utils/helpers.util';
import { IAppState } from 'config/redux/reducers';
import { IAddress, IUserState } from '../types/user.types';
import {
  userFetchAddresses as getUserAddressesAction,
  userAddAddress as userAddAddressAction,
} from '../redux/user.actions';
import useSessionArea from 'services/sessionArea/hooks/useSessionArea.hook';

import { IUserState as UserState } from 'common/User/redux/User.reducer';
import USER_CONFIG from 'config/User.config';

const useUser = (
  isFetchAddress = true
): [
  IUserState,
  IAddress,
  IAddress,
  {
    userAddAddress: (...args: any[]) => any;
  },
  UserState
] => {
  const [sessionArea] = useSessionArea();
  const dispatch = useDispatch();
  const userState = useSelector(({ userV2 }: IAppState) => userV2);
  const userData = useSelector((state: IAppState) => state.user);
  const userStateAddresses = useMemo(() => userState.addresses, [userState]);

  const userFetchAddresses = useCallback(() => dispatch(getUserAddressesAction()), [dispatch]);
  // TODO: add proper type for address arg
  const userAddAddress = useCallback(
    (address: { [K: string]: any }) => dispatch(userAddAddressAction(address)),
    [dispatch]
  );

  const defaultAddress = useMemo(() => {
    if (isNonEmptyArray(userStateAddresses)) {
      return userStateAddresses.filter(address => address.defaultAddress)[0];
    }
  }, [userStateAddresses]) as IAddress; // "as IAddress" - remove undefined type

  const sessionAreaMatchedUserAddr = useMemo(() => {
    if (isNonEmptyArray(userStateAddresses) && sessionArea) {
      return (
        userStateAddresses.filter(
          address => address.deliveryArea && address.deliveryArea.code === sessionArea
        )[0] || {}
      );
    }
  }, [sessionArea, userStateAddresses]) as IAddress; // "as IAddress" - remove undefined type

  useEffect(() => {
    if (isFetchAddress && USER_CONFIG.isLoggedIn) {
      userFetchAddresses();
    }
  }, [userFetchAddresses, isFetchAddress]);

  return [userState, defaultAddress, sessionAreaMatchedUserAddr, { userAddAddress }, userData];
};

export default useUser;
